// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__PD_oM","title":"ClientInsurance_title__hdjis","itemText":"ClientInsurance_itemText__5GMZE"};